import clsx from 'clsx';

import { Text, TextVariants } from '~/shared/components/Text/Text';

import styles from './productDetailsAttrList.module.css';

export type ProductDetailsAttrListSizes = 'sm' | 'lg';

export type ProductDetailsAttrListProps = {
	attrs: string[];
	size?: ProductDetailsAttrListSizes;
	className?: string;
};

/**
 * Component for displaying a dot separated horizontal list. Useful for displaying USPs.
 */
export const ProductDetailsAttrList = ({ attrs, className, size = 'sm' }: ProductDetailsAttrListProps) => {
	if (!attrs || !attrs.length) {
		return null;
	}

	const sizes: {
		[key in ProductDetailsAttrListSizes]: Extract<TextVariants, 'bodyXs' | 'body'>;
	} = {
		sm: 'bodyXs',
		lg: 'body',
	};

	return (
		<ul className={clsx(styles.root, className)}>
			{attrs.map((attr) => (
				<Text
					key={attr}
					as="li"
					variant={sizes[size]}
					className={styles.item}
				>
					{attr}
				</Text>
			))}
		</ul>
	);
};
